import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fortify-impersonate',
  templateUrl: './fortify-impersonate.component.html',
  styleUrls: ['./fortify-impersonate.component.scss']
})
export class FortifyImpersonateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
